import { render, staticRenderFns } from "./cervicalReport.vue?vue&type=template&id=624449c4&scoped=true"
import script from "./cervicalReport.vue?vue&type=script&lang=js"
export * from "./cervicalReport.vue?vue&type=script&lang=js"
import style0 from "./cervicalReport.vue?vue&type=style&index=0&id=624449c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624449c4",
  null
  
)

export default component.exports